import MemberDetailsModal from './MemberDetailsModal'

export default MemberDetailsModal
